import { Link, useNavigate } from "react-router-dom";
import { LogoDark, LogoLight } from "../../SVGComponents";
import { Facebook, Insta, Instagram, Linkedin, Twitter } from "../SvgCollection";
import footerBgLight from "../../../src/assets/images/footerbgLight.png";
import footerBgDark from "../../../src/assets/images/footerbgDark.png";
import { useEffect, useState } from "react";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";

const instruments = [
  { name: "Trade", path: "/spot/BTC_USDC" },
  { name: "P2P", path: "/p2p" },
  { name: "Stake", path: "/stake" },
  { name: "Market", path: "/market" },
];

const tradingLinks = [
  // { name: "FAQ ?", path: "/" },
  { name: "Privacy Policy", path: "/policy" },
  { name: "Terms & Conditions", path: "/terms_conditions" },
  { name: "Support", path: "/support" },
];

export default function Footer() {
  const nav = useNavigate();
  const theme = useSelector((state: RootState) => state.theme.theme);
  const [bannerBg, setBannerBg] = useState("");

  useEffect(() => {
    const loadImage = async () => {
      const imageModule = await import(
        theme === "dark"
          ? "../../assets/images/footerbgDark.png"
          : "../../assets/images/footerbgDark.png"
      );
      setBannerBg(imageModule.default); 
    };
    loadImage();
  }, [theme]);
  const gradient =
    theme === "dark"
      ? ""
      : "radial-gradient(circle at 50% 30%, #ffffff 20%, #4CAF50 100%)";
  const topGradient =
    theme === "dark"
      ? "linear-gradient(to bottom, rgba(0, 0, 0, 1), transparent)"
      : "linear-gradient(to bottom, rgba(255, 255, 255, 1), transparent)";

  const bottomGradient =
    theme === "dark"
      ? "linear-gradient(to top, rgba(0, 0, 0, 1), transparent)"
      : "linear-gradient(to top, rgba(255, 255, 255, 1), transparent)";
  const card = theme === "dark" ? "" : "";
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <footer className="z-[0]">
      <div
        className="dark:bg-rootBgColor bg-white pb-2 lg:pb-10  px-0 xs:px-0 sm:px-0 md:px-0 lg:px-[0px] xl:px-[00px] 2xl:px-[00px] 3xl:px-[100px] 4xl:px-[250px] 5xl:px-[500px] 6xl:px-[650px] 7xl:px-[800px] 8xl:px-[950px] 9xl:px-[1250px] 10xl:px-[1350px] 11xl:px-[1920px] 12xl:px-[2870px]"
        style={{
          // backgroundSize: "cover",

          // backgroundImage: `url(${bannerBg})`,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Top gradient BEHIND content */}
        {/* <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100px",
          background: topGradient,
          zIndex: 0, // behind the content
          pointerEvents: "none",
        }}
      /> */}

        {/* Bottom gradient also BEHIND */}
        {/* <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100px",
          background: bottomGradient,
          zIndex: 0,
          pointerEvents: "none",
        }}
      /> */}

        {/* Footer Content (zIndex 1 or default) */}
        <div
          className="relative   md:py-10 px-[140px] tTl:px-[80px] sTt:px-[60px] xTTs:px-[30px] xTs:px-[0px] xs:px-0 xs:pt-10 xTs:pt-10 xTTs:pt-10 sTt:pt-10 xl:pt-[50px] "
          style={{
            // backgroundSize: "cover",

            backgroundImage: `url(${bannerBg})`,
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100px",
              background: topGradient,
              zIndex: 0, // behind the content
              pointerEvents: "none",
            }}
          />

          {/* Bottom gradient also BEHIND */}
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "100px",
              background: bottomGradient,

              pointerEvents: "none",
            }}
          />

          {/* <div className="max-w-7xl mx-auto bg-black/5 backdrop-blur-md dark:bg-black/70 dark:backdrop-blur-lg text-black dark:text-white px-6 py-12 grid grid-cols-1 sm:grid-cols-2 gap-10 rounded-t-2xl"> */}
          {/* <div className="relative  max-w-7xl mx-auto bg-black/5 backdrop-blur-md dark:bg-black/70 dark:backdrop-blur-lg text-black dark:text-white px-6 py-14 grid grid-cols-1 sm:grid-cols-2 gap-10 rounded-t-2xl before:content-[''] before:absolute before:inset-0  before:rounded-[inherit] before:bg-gradient-to-br before:from-white/30 before:to-transparent before:blur-3xl"> */}
          <div className="relative   max-w-7xl mx-auto bg-black/5 backdrop-blur-md dark:bg-black/70 dark:backdrop-blur-lg text-black dark:text-white px-6 py-14 grid grid-cols-1 sm:grid-cols-2 gap-10 rounded-t-2xl">
            {/* Left Column */}
            <div className="space-y-4">
              <div
                onClick={() => {
                  nav("/");
                  scrollToTop();
                }}
                className="cursor-pointer"
              >
                <div className="block dark:hidden">
                  <LogoLight />
                </div>

                <div className="hidden dark:block">
                  <LogoDark />
                </div>
              </div>

              <p className="text-sm max-w-xs">
                CrymadX is a next-generation crypto trading platform offering secure, fast, and transparent access to digital assets. Built for traders, powered by innovation
              </p>
              <div className="flex gap-4 pt-2 items-center">
                <Link to="https://t.me/+0wvcvaOGlxU1MWNk" target="_blank">
                  <Facebook />
                </Link>
                <Link
                  to="https://x.com/crymadx?s=21&t=FF5tHuJ9sLq3XPyU6yRtqQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Twitter />
                </Link>

                <Link
                  to="https://www.instagram.com/crymadx?igsh=OXNzeHl3MjNiYjUx&utm_source=qr"
                  target="_blank"
                >
                  < Insta />
                </Link>
                <Link to="https://youtube.com/@crymadx?si=Zmi-hIJ2ZNFt1_m5" target="_blank">
                  <Linkedin />
                </Link>
              </div>
            </div>

            {/* Right Column */}
            <div className="grid grid-cols-2 gap-6 text-sm">
              <div>
                <h3 className="font-semibold mb-3">Main pages</h3>
                <ul className="space-y-2" onClick={scrollToTop}>
                  {instruments.map((item) => (
                    <li key={item.name}>
                      <Link to={item.path}>{item.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="font-semibold mb-3 invisible">Spacer</h3>
                <ul className="space-y-2" onClick={scrollToTop}>
                  {tradingLinks.map((item) => (
                    <li key={item.name}>
                      <Link to={item.path}>{item.name}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Footer Bottom Text */}

          <div className="max-w-7xl mx-auto w-full xTTs:mb-10 xTs:mb-10 xs:mb-10 bg-white dark:bg-black dark:text-gray-300 text-gray-700 text-center text-sm font-medium py-4 rounded-b-2xl shadow-sm lg:shadow-0 shadow-gray-500">
            Copyright ©{" "}
            <span className="text-themeColor font-bold">Crymadx</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
